"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = exports.ConfigProvider = exports.ConfigContext = exports.defaultConfig = void 0;
// @ts-nocheck
const client_1 = require("@apollo/client");
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const info_1 = __importDefault(require("../info"));
const ActionNestedFragment = (0, client_1.gql) `
  fragment ActionNestedFragment on Action {
    __typename
    ... on CommandReference {
      commandName
      commandVersion
      isCreationCommand
      isSynchronous
      isPublic
      hasNoAggregateIdCommand
      confirmationText
      limitMaxOccurrence
      isRedirectToDetails
      command {
        ... on FormCommand {
          template
        }
      }
      additionalActions {
        confirmationText
        buttons {
          label
          type
          aggregateName
          commandName
          commandVersion
        }
      }
    }
  }
`;
const ActionFragment = (0, client_1.gql) `
  fragment ActionFragment on Action {
    __typename
    ... on CommandReference {
      commandName
      commandVersion
      isCreationCommand
      isSynchronous
      isPublic
      hasNoAggregateIdCommand
      confirmationText
      limitMaxOccurrence
      isRedirectToDetails
      command {
        ... on FormCommand {
          template
        }
      }
      additionalActions {
        confirmationText
        buttons {
          label
          type
          aggregateName
          commandName
          commandVersion
        }
        actions {
          aggregateName
          action {
            ...ActionNestedFragment
          }
        }
      }
    }
    ... on BuiltInAction {
      actionName
    }
  }
  ${ActionNestedFragment}
`;
const ColorFragment = (0, client_1.gql) `
  fragment ColorFragment on ColorDefinition {
    __typename
    ... on HexColor {
      value
    }
    ... on ColorMap {
      colorKey
      mapping {
        hexColor
        value
      }
    }
    ... on ColorObject {
      hexColorKey
    }
  }
`;
const OtherAttributesFragment = (0, client_1.gql) `
  fragment OtherAttributesFragment on CardOtherAttributes {
    itemKey
    itemLabel
    placeholder
    color {
      ...ColorFragment
    }
    conditionalMap {
      nodes
      outputDefinition
    }
  }
`;
const CardDefinitionFragment = (0, client_1.gql) `
  ${ColorFragment}
  ${OtherAttributesFragment}
  fragment CardDefinitionFragment on CardDefinition {
    __typename
    ... on BasicCardDefinition {
      titleKey
      pageName
      secondaryButtons {
        label
        action {
          ...ActionFragment
        }
        canBePrimary
        icon
        color {
          ...ColorFragment
        }
      }
      primaryButton {
        label
        action {
          ...ActionFragment
        }
        canBePrimary
        icon
        color {
          ...ColorFragment
        }
      }
      template
      descriptionKey
      otherAttributes {
        ...OtherAttributesFragment
      }
    }
    ... on ConditionalCardDefinition {
      titleKey
      pageName
      descriptionKey
      showTitleLabel
      template
      otherAttributes {
        ...OtherAttributesFragment
      }
      buttons {
        action {
          ...ActionFragment
        }
        icon
        label
        canBePrimary
        conditionalMap {
          nodes
          outputDefinition
        }
        color {
          ...ColorFragment
        }
      }
    }
  }
`;
const GET_CONFIG = (0, client_1.gql) `
  query {
    webUIConfig {
      geographic {
        showPolylineMeasurement
        polylineUnitOfMeasurement
        polylineRoundingPrecision
      }
      multiselectPageSize
      functions
      pages
      fabActions {
        label
        icon
        aggregate {
          name
        }
        conditionalMap {
          nodes
          outputDefinition
        }
        action {
          ...ActionFragment
        }
      }
      importActions {
        label
        icon
        fileTypes
        isIntegrationImport
        aggregate {
          name
        }
        conditionalMap {
          nodes
          outputDefinition
        }
        action {
          ...ActionFragment
        }
      }
      navigations
      aggregateDefinitions {
        hiddenFromTableView
        hiddenFromMapView
        queryKey
        name
        plural
        singular
        labelProperty
        showMeasurementOnMap
        detailPage
        isReferenceType
        propertyDefinitions {
          field
          label
          uiType
          type
          isRelationship
          isEditable
          relationshipType
          foreignColumn
          validOptions {
            enum
          }
        }
        tableActions {
          label
          icon
          label
          conditionalMap {
            nodes
            outputDefinition
          }
          icon
          action {
            ...ActionFragment
          }
        }
        multiSelectActions {
          label
          icon
          limitMaxOccurrence
          conditionalMap {
            nodes
            outputDefinition
          }
          action {
            ...ActionFragment
          }
        }
        editorWorkflows {
          label
          icon
          action {
            ...ActionFragment
          }
          conditionalMap {
            nodes
            outputDefinition
          }
        }
        cardDefinition {
          ...CardDefinitionFragment
        }
        mapLabelProperties {
          name
        }
        showMapLabelTitles
        showEmptyMapLabels
      }
      theme {
        primary
        secondary
        logoUrl
      }
      line {
        editColor
      }
      colorPalettes {
        name
        colors
      }
      primaryPalette
      labels {
        applicationName
        copyrightInfo
      }
      symbolLegend {
        name
        symbolKey
      }
      initialMapExtents {
        lat
        lon
        zoom
      }
      enabledFeatures {
        attributeSearchOnMap
        analyticsModule
        showLogin
      }
      applicationName
      defaultPage
      refreshTokenTimeout
      symbolScaleFactor
      analyticsTrustedServerUrl
      analyticsMaxSeatCount
      defaultDateTimeFormat {
        dateFormatType
        dateFormat
        dateSeperator
        timeFormat
        isSwitch
      }
      integrations {
        nearMaps
        nearMapsKey
        mapServices
        pusherKey
        pusherCluster
        pusherAppId
        floorPlans
        blueForceTracking {
          enabled
          projectId
          backgroundTimeout
          locationFrequencyScale
        }
      }
      selectedProjectsMaxRecords
      googleMapsApiKey
      languages {
        default
        supportedLanguages
      }
      translations
    }
  }
  ${ActionFragment}
  ${CardDefinitionFragment}
`;
exports.defaultConfig = {
    geographic: {
        showPolylineMeasurement: false,
        polylineUnitOfMeasurement: 'feet',
        polylineRoundingPrecision: 'tenths',
    },
    defaultPage: '/',
    functions: '',
    pages: '',
    aggregateDefinitions: [],
    fabActions: [],
    importActions: [],
    theme: {
        primary: '#56CCF2',
        secondary: '#455157',
        logoUrl: '/static/media/terrago-streetlights-logo-512.6fc4397f.png',
    },
    line: {
        editColor: '#FF0000',
    },
    labels: {
        applicationName: 'TerraGo Streetlights',
        copyrightInfo: 'Copyright 2019 TerraGo Technologies, Inc',
    },
    symbolLegend: [],
    initialMapExtents: {
        lat: '39.8283',
        lon: '-98.5795',
        zoom: 4,
    },
    defaultAggregate: '',
    enabledFeatures: { attributeSearchOnMap: false, analyticsModule: false, showLogin: 'both' },
    applicationName: 'TerraGo Streetlights',
    symbolScaleFactor: 1,
    analyticsMaxSeatCount: 0,
    defaultDateTimeFormat: {
        dateFormatType: gen5_shared_utilities_1.DEFAULT_DATETIME_FORMAT.DateFormatType,
        dateFormat: gen5_shared_utilities_1.DEFAULT_DATETIME_FORMAT.DateFormat,
        dateSeperator: gen5_shared_utilities_1.DEFAULT_DATETIME_FORMAT.DateSeperator,
        timeFormat: gen5_shared_utilities_1.DEFAULT_DATETIME_FORMAT.TimeFormat,
        isSwitch: gen5_shared_utilities_1.DEFAULT_DATETIME_FORMAT.IsSwitch,
    },
    integrations: {
        nearMaps: false,
        nearMapsKey: undefined,
        mapServices: false,
        pusherKey: undefined,
        pusherCluster: undefined,
        pusherAppId: undefined,
        floorPlans: false,
        blueForceTracking: {
            enabled: false,
            projectId: '',
            backgroundTimeout: 60,
            locationFrequencyScale: 100,
        },
    },
    selectedProjectsMaxRecords: gen5_shared_utilities_1.defaultProjectRecordsLimit.WEB,
    languages: {
        default: 'English',
        supportedLanguages: ['English'],
    },
};
const appInfo = {
    productVersion: info_1.default.productVersion,
    version: info_1.default.version,
    ciBuildtimestamp: info_1.default.ciBuildtimestamp,
    commit: info_1.default.commit,
    ciBuildNumber: info_1.default.ciBuildNumber,
};
exports.ConfigContext = (0, react_1.createContext)(exports.defaultConfig);
const ConfigProvider = ({ children, onConfigChanged }) => {
    const { data, loading, error } = (0, client_1.useQuery)(GET_CONFIG, { fetchPolicy: 'no-cache' });
    // use memo since I create a new object for now to avoid rerendering
    const configuration = (0, react_1.useMemo)(() => data
        ? Object.assign(Object.assign({}, data.webUIConfig), { functionDefinitions: JSON.parse(data.webUIConfig.functions), pageDefinitions: JSON.parse(data.webUIConfig.pages), defaultAggregate: 'Asset', appInfo }) : null, [data]);
    (0, react_1.useEffect)(() => {
        if (error || loading || !configuration) {
            return;
        }
        onConfigChanged === null || onConfigChanged === void 0 ? void 0 : onConfigChanged(configuration); // TODO: [S5-3741] Migrate to `Effects` component, or shared recoil.
    }, [onConfigChanged, configuration]);
    if (error) {
        throw new Error(error.message);
    }
    if (loading) {
        return null;
        // return <p>Loading...</p>;
    }
    if (!configuration) {
        return null;
    }
    return (react_1.default.createElement(exports.ConfigContext.Provider, { value: configuration },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_helmet_1.Helmet, null,
                react_1.default.createElement("title", null, configuration.applicationName)),
            children)));
};
exports.ConfigProvider = ConfigProvider;
const useConfig = () => (0, react_1.useContext)(exports.ConfigContext);
exports.useConfig = useConfig;
//# sourceMappingURL=configContext.js.map